import { useTranslation } from 'react-i18next';

export default function ProfitFlywheel() {
  const { t } = useTranslation();
  const flywheelSteps = [
    { id: 1, title: t('profitFlywheel.step1_title'), subtitle: t('profitFlywheel.step1_sub'), description: t('profitFlywheel.step1_desc'), icon: 'ri-global-line', tech: t('profitFlywheel.step1_tech'), techDetail: t('profitFlywheel.step1_techDetail') },
    { id: 2, title: t('profitFlywheel.step2_title'), subtitle: t('profitFlywheel.step2_sub'), description: t('profitFlywheel.step2_desc'), icon: 'ri-brain-line', tech: t('profitFlywheel.step2_tech'), techDetail: t('profitFlywheel.step2_techDetail') },
    { id: 3, title: t('profitFlywheel.step3_title'), subtitle: t('profitFlywheel.step3_sub'), description: t('profitFlywheel.step3_desc'), icon: 'ri-search-eye-line', tech: t('profitFlywheel.step3_tech'), techDetail: t('profitFlywheel.step3_techDetail') },
    { id: 4, title: t('profitFlywheel.step4_title'), subtitle: t('profitFlywheel.step4_sub'), description: t('profitFlywheel.step4_desc'), icon: 'ri-flashlight-line', tech: t('profitFlywheel.step4_tech'), techDetail: t('profitFlywheel.step4_techDetail') },
    { id: 5, title: t('profitFlywheel.step5_title'), subtitle: t('profitFlywheel.step5_sub'), description: t('profitFlywheel.step5_desc'), icon: 'ri-money-dollar-circle-line', tech: t('profitFlywheel.step5_tech'), techDetail: t('profitFlywheel.step5_techDetail') },
    { id: 6, title: t('profitFlywheel.step6_title'), subtitle: t('profitFlywheel.step6_sub'), description: t('profitFlywheel.step6_desc'), icon: 'ri-recycle-line', tech: t('profitFlywheel.step6_tech'), techDetail: t('profitFlywheel.step6_techDetail') },
    { id: 7, title: t('profitFlywheel.step7_title'), subtitle: t('profitFlywheel.step7_sub'), description: t('profitFlywheel.step7_desc'), icon: 'ri-line-chart-line', tech: t('profitFlywheel.step7_tech'), techDetail: t('profitFlywheel.step7_techDetail') },
    { id: 8, title: t('profitFlywheel.step8_title'), subtitle: t('profitFlywheel.step8_sub'), description: t('profitFlywheel.step8_desc'), icon: 'ri-funds-line', tech: t('profitFlywheel.step8_tech'), techDetail: t('profitFlywheel.step8_techDetail') },
  ];

  const sumItems = [
    { icon: 'ri-database-2-line', labelKey: 'profitFlywheel.sum0_label', techKey: 'profitFlywheel.sum0_tech', detailKey: 'profitFlywheel.sum0_detail' },
    { icon: 'ri-code-box-line', labelKey: 'profitFlywheel.sum1_label', techKey: 'profitFlywheel.sum1_tech', detailKey: 'profitFlywheel.sum1_detail' },
    { icon: 'ri-coins-line', labelKey: 'profitFlywheel.sum2_label', techKey: 'profitFlywheel.sum2_tech', detailKey: 'profitFlywheel.sum2_detail' },
    { icon: 'ri-loop-right-line', labelKey: 'profitFlywheel.sum3_label', techKey: 'profitFlywheel.sum3_tech', detailKey: 'profitFlywheel.sum3_detail' },
  ];

  const keyPoints = [
    { icon: 'ri-loop-right-line', titleKey: 'profitFlywheel.key0_title', descKey: 'profitFlywheel.key0_desc' },
    { icon: 'ri-robot-2-line', titleKey: 'profitFlywheel.key1_title', descKey: 'profitFlywheel.key1_desc' },
    { icon: 'ri-infinity-line', titleKey: 'profitFlywheel.key2_title', descKey: 'profitFlywheel.key2_desc' },
  ];

  const formulaItems = [
    { labelKey: 'profitFlywheel.f0_label', value: 'Data' },
    { labelKey: 'profitFlywheel.f1_label', value: 'Arbitrage' },
    { labelKey: 'profitFlywheel.f2_label', value: 'Profit' },
    { labelKey: 'profitFlywheel.f3_label', value: 'Compound' },
    { labelKey: 'profitFlywheel.f4_label', value: 'Scale' },
    { labelKey: 'profitFlywheel.f5_label', value: 'More Arb' },
  ];

  return (
    <section id="flywheel" className="py-24 relative overflow-hidden" style={{ background: 'linear-gradient(180deg, #100b1e 0%, #0c0814 100%)' }}>
      <div className="absolute inset-0 grid-bg pointer-events-none opacity-50" />
      <div className="max-w-7xl mx-auto px-4 md:px-6 relative z-10">
        <div className="text-center mb-10 md:mb-16">
          <div className="badge-purple mb-6">{t('profitFlywheel.badge')}</div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-5 font-heading">
            {t('profitFlywheel.title1')}
            <span className="text-gradient-aurora"> {t('profitFlywheel.title2')}</span>
          </h2>
          <p className="text-lg text-white/55 max-w-3xl mx-auto">
            {t('profitFlywheel.desc')}
          </p>
        </div>

        {/* Mobile list */}
        <div className="md:hidden space-y-3 mb-6">
          {flywheelSteps.map((step) => (
            <div key={step.id} className="premium-card rounded-xl p-4 flex items-start gap-3">
              <div className="w-7 h-7 rounded-full flex items-center justify-center text-xs font-black text-white flex-shrink-0 mt-0.5"
                style={{ background: 'linear-gradient(135deg,#9333ea,#7c3aed)' }}>{step.id}</div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1 flex-wrap">
                  <i className={`${step.icon} text-purple-400 text-sm`}></i>
                  <span className="text-sm font-bold text-white">{step.title}</span>
                  <span className="text-xs font-semibold text-purple-300 px-2 py-0.5 rounded-full whitespace-nowrap"
                    style={{ background: 'rgba(168,85,247,0.15)', border: '1px solid rgba(168,85,247,0.25)' }}>{step.tech}</span>
                </div>
                <p className="text-xs text-white/50 leading-relaxed">{step.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Desktop circle */}
        <div className="hidden md:block relative max-w-5xl mx-auto mb-14">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-20">
            <div className="w-52 h-52 rounded-full flex items-center justify-center relative"
              style={{ background: 'linear-gradient(135deg, #2d0a5e, #1a0540)', border: '1px solid rgba(168,85,247,0.3)', boxShadow: '0 0 50px rgba(168,85,247,0.2)' }}>
              <div className="text-center relative z-10">
                <i className="ri-cpu-line text-4xl text-purple-400 mb-2 block"></i>
                <div className="text-lg font-bold text-white font-heading">PolyAi-Claw</div>
                <div className="text-xs text-purple-400/60">{t('profitFlywheel.aiCore')}</div>
              </div>
            </div>
            <div className="absolute inset-0 rounded-full border border-purple-400/20 animate-spin" style={{ animationDuration: '20s' }}></div>
          </div>
          <div className="relative w-full aspect-square mx-auto">
            {flywheelSteps.map((step, index) => {
              const angle = (index * 360) / flywheelSteps.length - 90;
              const radius = 45;
              const x = 50 + radius * Math.cos((angle * Math.PI) / 180);
              const y = 50 + radius * Math.sin((angle * Math.PI) / 180);
              return (
                <div key={step.id} className="absolute group cursor-pointer" style={{ left: `${x}%`, top: `${y}%`, transform: 'translate(-50%, -50%)' }}>
                  <div className="w-20 h-20 rounded-2xl flex items-center justify-center group-hover:scale-110 transition-all duration-300 premium-card">
                    <i className={`${step.icon} text-3xl text-purple-400`}></i>
                  </div>
                  <div className="mt-1.5 flex justify-center">
                    <span className="text-xs font-semibold text-purple-300 px-2 py-0.5 rounded-full whitespace-nowrap"
                      style={{ background: 'rgba(168,85,247,0.15)', border: '1px solid rgba(168,85,247,0.25)' }}>{step.tech}</span>
                  </div>
                  <div className="absolute top-full mt-8 left-1/2 -translate-x-1/2 w-52 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-30">
                    <div className="premium-card rounded-xl p-4 border border-purple-400/25" style={{ background: 'rgba(18,8,40,0.97)' }}>
                      <div className="flex items-center gap-2 mb-2">
                        <div className="w-5 h-5 rounded-md flex items-center justify-center flex-shrink-0" style={{ background: 'rgba(168,85,247,0.2)' }}>
                          <i className={`${step.icon} text-xs text-purple-400`}></i>
                        </div>
                        <div className="text-sm font-bold text-white font-heading">{step.title}</div>
                      </div>
                      <div className="flex items-center gap-1.5 mb-2.5 px-2.5 py-1.5 rounded-lg" style={{ background: 'rgba(168,85,247,0.12)', border: '1px solid rgba(168,85,247,0.2)' }}>
                        <i className="ri-cpu-line text-purple-400 text-xs"></i>
                        <span className="text-xs font-bold text-purple-300">{step.tech}</span>
                        <span className="text-xs text-white/40 ml-1">{step.techDetail}</span>
                      </div>
                      <div className="text-xs text-white/55 leading-relaxed">{step.description}</div>
                    </div>
                  </div>
                  <div className="absolute -top-2 -right-2 w-6 h-6 rounded-full flex items-center justify-center text-xs font-black text-white"
                    style={{ background: 'linear-gradient(135deg,#9333ea,#7c3aed)' }}>{step.id}</div>
                </div>
              );
            })}
            <svg className="absolute inset-0 w-full h-full pointer-events-none" style={{ transform: 'rotate(-90deg)' }}>
              <circle cx="50%" cy="50%" r="45%" fill="none" stroke="rgba(168,85,247,0.1)" strokeWidth="1" strokeDasharray="8 4" className="animate-spin" style={{ animationDuration: '30s' }} />
            </svg>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-10 md:mb-12">
          {sumItems.map(item => (
            <div key={item.labelKey} className="premium-card rounded-xl p-4 flex items-center gap-3">
              <div className="w-10 h-10 flex-shrink-0 rounded-xl bg-purple-400/10 border border-purple-400/20 flex items-center justify-center">
                <i className={`${item.icon} text-lg text-purple-400`}></i>
              </div>
              <div className="min-w-0">
                <div className="text-xs text-white/45 mb-0.5">{t(item.labelKey)}</div>
                <div className="text-sm font-bold text-purple-300 truncate">{t(item.techKey)}</div>
                <div className="text-xs text-white/40 truncate">{t(item.detailKey)}</div>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 mb-8 md:mb-12">
          {keyPoints.map(item => (
            <div key={item.titleKey} className="premium-card premium-card-hover rounded-xl p-6">
              <div className="w-12 h-12 rounded-xl bg-purple-400/10 border border-purple-400/20 flex items-center justify-center mb-4">
                <i className={`${item.icon} text-2xl text-purple-400`}></i>
              </div>
              <h3 className="text-lg font-bold text-white mb-2 font-heading">{t(item.titleKey)}</h3>
              <p className="text-white/55 text-sm leading-relaxed">{t(item.descKey)}</p>
            </div>
          ))}
        </div>

        <div className="bg-white/[0.02] border border-purple-500/10 rounded-xl p-5 md:p-8">
          <h3 className="text-xl md:text-2xl font-bold text-white mb-6 text-center font-heading">{t('profitFlywheel.formula_title')}</h3>
          <div className="flex flex-wrap items-center justify-center gap-2 md:gap-4">
            {formulaItems.map((item, i, arr) => (
              <>
                <div key={item.value} className="text-center">
                  <div className="text-xs text-white/45 mb-1">{t(item.labelKey)}</div>
                  <div className="text-lg font-bold text-purple-400 font-heading">{item.value}</div>
                </div>
                {i < arr.length - 1 && <i key={`arrow-${i}`} className="ri-arrow-right-line text-lg text-purple-400/30"></i>}
              </>
            ))}
            <i className="ri-corner-down-left-line text-lg text-purple-400/30"></i>
          </div>
        </div>
      </div>
    </section>
  );
}
